import { render, staticRenderFns } from "./TicketBookings.vue?vue&type=template&id=5b3da9cf&scoped=true"
import script from "./TicketBookings.vue?vue&type=script&lang=js"
export * from "./TicketBookings.vue?vue&type=script&lang=js"
import style0 from "./TicketBookings.vue?vue&type=style&index=0&id=5b3da9cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3da9cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VChip,VDivider,VFlex,VLayout,VProgressLinear})
